import React from "react";
import { Grid, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import "../assets/css/header.css";
import "../assets/css/icon.css";
import { actions, logout } from "../model";
import { useDispatch, useSelector } from "react-redux";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const handleLogout = () => {
    const path = location.pathname;

    if (path.startsWith("/evaluation")) {
      navigate("/");
    } else {
      dispatch(actions.logout());
    }
  };

  return (
    <Grid
      container
      className="bg-blue-dark"
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "5px 0px",
        alignItems: "center",
      }}
    >
      {/* logo */}
      <Grid
        item
        xs={2}
        md={1}
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div className="logo-lexia-header" />
      </Grid>

      {/* titolo */}
      <Grid
        item
        xs={8}
        md={10}
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Typography className="color-light title-header">E-Valuo</Typography>
      </Grid>

      {/* icona logout/back */}
      <Grid
        item
        xs={2}
        md={1}
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          onClick={handleLogout}
          className="icon-logout container-icon"
          aria-label="Logout"
          style={{ cursor: "pointer" }}
        ></div>
      </Grid>
    </Grid>
  );
};

export default Header;
